import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Flex, HStack, Link, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import errorImage from '../../500.png';

const ErrorPage = ({ error }) => {
  if (error && error.status === 401) {
    return (
      <Box bgColor="white">
        <HStack alignItems="center" h="100vh" justify="center" w="100%">
          <Flex direction="column" h="300px" justify="center" textAlign="left" w="35%">
            <Text textStyle="displayXs600">
              Sorry, your session has expired. You will soon be redirected.
            </Text>
          </Flex>
          <Box>
            <img alt="Something went wrong" src={errorImage} />
          </Box>
        </HStack>
      </Box>
    );
  }

  return (
    <Box bgColor="white">
      <HStack alignItems="center" h="600px" justify="center" w="100%">
        <Flex direction="column" h="300px" justify="center" textAlign="left" w="35%">
          <Text textStyle="displayXs600">
            Sorry, something is wrong.
          </Text>
          <Text color="greyScale.600" mt={8}>
            This should be fixed in no time. Try
            {' '}
            <Link color="primaryScale.900" href={window.location.href}>refreshing the page</Link>
            {' or '}
            <Link
              color="primaryScale.900"
              href="https://support.google.com/accounts/answer/32050"
              rel="nofollow norefferer"
              target="_blank"
            >
              clearing cache & cookies.
            </Link>
          </Text>
          <Text color="greyScale.600" maxW="90%" mt={4}>
            If you still need help, please contact the helpdesk at
            {' '}
            <span
              style={{ fontWeight: '600' }}
            >
              support@pinsadvantage.com
            </span>
            .
          </Text>
        </Flex>
        <Box>
          <img alt="Something went wrong" src={errorImage} />
        </Box>
      </HStack>
    </Box>
  );
};

ErrorPage.propTypes = { error: PropTypes.instanceOf(Error) };

export default ErrorPage;
